import { createBrowserClient } from "@supabase/ssr";
import type { Database } from "@/types/database";

export function createClient() {
	return createBrowserClient<Database>(
		process.env.NEXT_PUBLIC_SUPABASE_URL!,
		process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
	);
}

// create client for submissions table
export function createSubmissionsClient() {
	return createBrowserClient<Database>(
		process.env.NEXT_PUBLIC_SUBMISSIONS_URL!,
		process.env.NEXT_PUBLIC_SUBMISSIONS_ANON_KEY!,
	);
}
